<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>출판 준비 체크</span>
                        <h1>원고 출판 준비</h1>
                        <p>20개 이상의 표준 출판 요구 사항에 따라 원고를 평가하여 저널 심사를 더욱 신속하게 통과해 보세요. 트링카를 사용하면 원고가
                            <br>목표 저널의 범위와 일치하는 정도도 확인할 수 있습니다.
                        </p>
                        <a href="https://cloud.trinka.ai/signup?_rg=KR" id="autoEditGetStart" target="_blank">시작하기</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <!-- <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/PublicationReadinessChecksImg.png" alt="">
                    </div> -->
                    <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                        <!-- <img src="../../../assets/images/PublicationReadinessChecksImg.png" alt=""> -->
                        <ul>
                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/JournalScope.svg" alt="scope">
                                </div>
                                <h3>저널 범위 매칭</h3>
                                <span>2 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/TechnicalCompliance.svg" alt="compliance">
                                </div>
                                <h3>기술적 준수</h3>
                                <span>3 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/EthicalCompliance.svg" alt="ethical">
                                </div>
                                <h3>윤리기준 준수</h3>
                                <span>5 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/AuthorshipDetails.svg" alt="authorship">
                                </div>
                                <h3>원저자 정보</h3>
                                <span>4 Checks</span>
                            </li>
                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/ReferenceDetails.svg" alt="reference">
                                </div>
                                <h3>참고문헌 정보</h3>
                                <span>1 Check</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/FirgureTable.svg" alt="figure">
                                </div>
                                <h3>표와 그림</h3>
                                <span>2 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/ClinicalTrials.svg" alt="clinical">
                                </div>
                                <h3>임상시험 정보</h3>
                                <span>1 Check</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/KeywordsAndSummary.svg" alt="keywords">
                                </div>
                                <h3>키워드 & 요약</h3>
                                <span>2 Checks</span>
                            </li>
                            <i></i>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="how_it_work_section" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>이렇게 사용하세요</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/RegisterAndLogin.png" alt="login">
                                </div>
                                <h3>등록 / 로그인</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="import">
                                </div>
                                <h3>파일 열기/가져오기 &
                                    <br /> 게재 상태 검사 선택</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="writing">
                                </div>
                                <h3>상세한 평가
                                    <br /> 보고서를 받습니다</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="SectionHowItWrok" #viewVideo>
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/PublicationCheckThumbnail.png" alt="thumbnail" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>이렇게 사용하세요</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">이 짧은 안내 동영상을 통해 20개 이상의 출판 준비 체크포인트를 사용하여 출판일을 앞당기는 방법을 알아보세요.</p>
                        <p style="margin-bottom: 10px;">트링카를 최대한 활용할 수 있도록 단계별로 상세하게 안내해 드립니다. 더 궁금한 사항이 있으신가요?
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">여기</a>에서 FAQ를 찾아보세요.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>게재 상태 검사의 주요 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카 논문 게재 상태 검사를 통해, 20가지 이상의 출판 준비 체크 사항을 평가하고 교정하여 출판의 가능성을 높입니다.</p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/JournalScope.svg" alt="scope">
                        </div>
                        <h3>저널 범위 매칭</h3>
                        <p>논문이 목표 저널의 범위와 일치하는지 확인하여 논문 거절을 최소화하고 추가로
                            <br>일치하는 저널을 제안합니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/TechnicalCompliance.svg" alt="technical">
                        </div>
                        <h3>기술적 준수</h3>
                        <p>트링카는 초록, 단어 수, 논문의 하위 제목 등 여러 출판 준수사항을 확인하므로 모든 출판 조건을 충족할 수 있습니다.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/EthicalCompliance.svg" alt="ethical">
                        </div>
                        <h3>윤리기준 준수</h3>
                        <p>편집위원 심사에 원활히 통과하기 위해 사전 동의, 윤리적 승인, 재무적 공개,
                            <br>이해관계 충돌과 같은 모든 의무사항을 명확히 했는지 확인합니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/AuthorshipDetails.svg" alt="authorship">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>원저자 정보</h3>
                        <p>대부분의 저널에서 요구하는 저자 이름,
                            <br>소속, 교신 저자, 기여도 공개와 같은 원저자 상세 정보를 확인합니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/ReferenceDetails.svg" alt="reference" width="30" height="38">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>참고문헌 정보</h3>
                        <p>트링카는 참고문헌을 확인하여 오래된
                            <br>참고문헌을 사용한 경우 이를 알려줍니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/FirgureTable.svg" alt="figure">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>표와 그림</h3>
                        <p>트링카는 모든 제출 요구조건을 충족하는지 확인하기 위해 표와 그림의 모든 캡션과 인용을 확인합니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/ClinicalTrials.svg" alt="clinical" width="29" height="35">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>임상시험 정보</h3>
                        <p>트링카는 임상시험 ID를 언급했는지 확인하고 해당 임상시험의 정보를 불러오므로 항상 올바른 세부 정보를 제공할 수 있습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/KeywordsAndSummary.svg" alt="keywords">
                        </div>
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>키워드 & 요약</h3>
                        <p>최첨단 영문교정AI툴 트링카는 논문의 전체를 잘 요약하여 논문의 중요한 주제와 컨셉을 부각해 주고 논문의 적절한 키워드를 제안합니다.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>자주하는 질문</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        출판 준비 체크는 크레딧이 얼마나 드나요?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>출판 준비 체크 기능을 실행할 때마다 1크레딧이 소모됩니다. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        출판 준비 보고서를 다운로드할 수 있을까요? </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>현재로서는 출판 준비 보고서 다운로드가 불가능합니다. 그러나 Trinka Cloud에서 해당 보고서를 항상 사용하실 수 있습니다. 등록하신 이메일
                                            ID로도 각각의 보고서로 연결되는 링크를 보내드립니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        트링카 베이직 플랜에서 출판 준비 체크 기능을 사용할 수 있나요?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>예. 이 기능은 크레딧을 사용합니다. 베이직 구독 사용자에게는 매월 무료로 4크레딧을 드리는데, 이를 출판 준비 보고서를 받아보는 데 사용하실 수
                                            있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        출판 준비 보고서는 어떻게 사용하나요?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>출판 준비 보고서를 체크리스트로 활용하면 목표 저널의 요구 사항과 손쉽게 비교하여 논문의 준비 상태를 수월하게 평가할 수 있습니다. 보고서의 이해를
                                            돕기 위한
                                            <a style="color: #0000ff;" (click)="scroll(viewVideo)" class="link">동영상</a> 도 준비되어 있습니다.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        출판 가능성을 높여주는 트링카 출판 준비 체크
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>저널 선정에서 윤리기준 준수까지 20가지 이상의 체크포인트로 문서를 평가하여 출판 가능성을 높여 드립니다.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>다른 앱에서
                                    <br /> 트링카 사용</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/kr/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                            <h3>클라우드</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser-icon">
                                            <h3>브라우저 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">기업</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/c8yyiW2tEjE"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>